import React from 'react';
import get from 'lodash.get';
import { Box, Text } from '@neta';
import SelectItem from './SelectItem';

export default class SelectItems extends React.Component {
  renderUngrouped({ options, getItemProps, highlightedIndex, selectedItem }) {
    return options.map((item, index) => (
      <SelectItem
        key={index}
        item={item}
        index={index}
        getItemProps={getItemProps}
        highlightedIndex={highlightedIndex}
        selectedItem={selectedItem}
      />
    ));
  }

  renderGrouped({ unGroupedOptions, getItemProps, highlightedIndex, selectedItem }) {
    const { groupTitles, options: groupedOptions } = this.props;

    let groupCount = 0;
    let endOfGroupIndex = groupedOptions[groupCount].length - 1;
    let groupIndex = 0;

    return unGroupedOptions.map((item, index) => {
      const renderedItem = (
        <SelectItem
          key={index}
          item={item}
          index={index}
          getItemProps={getItemProps}
          highlightedIndex={highlightedIndex}
          selectedItem={selectedItem}
        />
      );
      const renderBreakpoint = groupIndex === endOfGroupIndex;
      if (renderBreakpoint) {
        groupIndex = 0;
        groupCount += 1;
        const nextGroup = groupedOptions[groupCount];
        endOfGroupIndex = nextGroup && nextGroup.length;

        return nextGroup ? (
          <Box key={index} borderBottom="divider" pb={3} mb={3}>
            {renderedItem}
          </Box>
        ) : (
          renderedItem
        );
      } else if (groupIndex === 0 && groupTitles[groupCount]) {
        groupIndex += 1;
        return (
          <Box key={index}>
            <Box pl={3} mb={2}>
              <Text.caption color="grayscale.stone">
                {groupTitles[groupCount]}
              </Text.caption>
            </Box>
            {renderedItem}
          </Box>
        );
      } else {
        groupIndex += 1;
        return renderedItem;
      }
    });
  }

  render() {
    const {
      bg,
      forAutocomplete,
      getItemProps,
      highlightedIndex,
      options,
      selectedItem,
      topContent,
      unGroupedOptions
    } = this.props;
    const isGrouped = !!get(options, '0.length');
    const styles = forAutocomplete
      ? {
          borderTopWidth: 0,
          borderTopLeftRadius: 0,
          borderTopRightRadius: 0,
          left: -1,
          top: 0
        }
      : {
          left: 0,
          top: 3
        };
    return (
      <div style={{ position: 'relative' }}>
        <Box
          bg={bg ? bg : 'grayscale.white'}
          border="divider"
          borderRadius="4px"
          width={`calc(100%${forAutocomplete ? ' + 2px' : ''})`}
          maxHeight="200px"
          style={{
            overflowY: 'auto',
            position: 'absolute',
            zIndex: 1,
            ...styles
          }}
        >
          {topContent}
          {isGrouped
            ? this.renderGrouped({
                unGroupedOptions,
                getItemProps,
                highlightedIndex,
                selectedItem
              })
            : this.renderUngrouped({
                options,
                getItemProps,
                highlightedIndex,
                selectedItem
              })}
        </Box>
      </div>
    );
  }
}
